<template>
  <d2-container>
    <el-table
      size="small"
      :key="tableKey"
      stripe
      border
      highlight-current-row
      style=" margin-top: 20px"
      :data="baseList"
    >
      <el-table-column align="center" label="id">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="名称">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="图标">
        <template slot-scope="scope">
          <img style="width:97px;height:97px" :src="scope.row.icon" />
        </template>
      </el-table-column>
      <el-table-column align="center" label="影响值">
        <template slot-scope="scope">
          <span>{{ scope.row.value }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="介绍">
        <template slot-scope="scope">
          <span>{{ scope.row.subtitle }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" fixed="right" width="240">
        <template slot-scope="scope">
          <el-button
            size="small"
            type="danger"
            @click="delCont(scope.row.id,scope.row.name,scope.row.value)"
            :disabled="scope.row.value == 0 ? true :false"
            style="margin-top: 10px;"
          >扣除基础属性</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :title="attribute" :visible.sync="centerDialogVisible" width="40%" center>
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="属性值" required prop="value">
          <el-input-number v-model="form.value" :step="1" :min="0" :max="val" size="mini"></el-input-number>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="form.remark" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="getDetermine">确 定</el-button>
      </span>
    </el-dialog>
  </d2-container>
</template>
<script>
import { mapGetters } from 'vuex'
import { getAttrBase, getBaseSet } from '@/api/demo/certificateList/index'
export default {
  name: 'certbaseList',
  computed: {
    ...mapGetters(['elements'])
  },
  data () {
    return {
      tableKey: 0,
      closeData: [], // 数据
      total: null,
      baseList: [], // 基础属性集合
      certId: '',
      attribute: '',
      centerDialogVisible: false,
      form: {
        attrId: null, // 账户
        remark: '', // 增加属性成长值
        userCertId: null, // 用户亲密证书id
        value: 0 // 增加属性成长值
      },
      rules: {},
      val: null
    }
  },
  watch: {
    $route (to, from) {}
  },
  created () {
    this.certId = this.$route.query.id
    console.log('this.certId', this.certId)
    // if (this.certId == null) {
    //   let that = this;
    //   that.$router.push({
    //     path: "../../demo/certificateList/"
    //   });
    //   return false
    // }
    this.getSearch()
  },
  mounted () {},
  methods: {
    // 搜索条件
    getSearch () {
      let that = this
      let data = { userCertId: this.certId }
      getAttrBase(data).then(res => {
        that.listLoading = true
        that.baseList = res
        that.listLoading = false
      })
    },
    // 扣除基础属性
    delCont (id, name, val) {
      let that = this
      if (this.certId == null) {
        let that = this
        that.$router.push({
          path: '../../demo/certificateList'
        })
        return false
      }
      that.val = val
      that.attribute = name
      that.form.attrId = id
      that.form.userCertId = that.certId
      that.centerDialogVisible = true
    },
    // 扣除
    getDetermine (id) {
      let that = this
      that
        .$confirm('此操作将永久扣除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          getBaseSet(that.form).then(() => {
            that.getSearch()
            that.$notify({
              title: '成功',
              message: '扣除成功',
              type: 'success',
              duration: 2000
            })
            that.centerDialogVisible = false
          })
        })
        .catch(() => {
          that.$message({
            type: 'info',
            message: '已取消扣除'
          })
          that.centerDialogVisible = false
        })
    }
  }
}
</script>

<style scoped>
.baseList {
  display: flex;
}
.baseList span {
  padding: 10px 20px;
  width: 180px;
  display: block;
}
</style>
